import React, { useCallback, useState } from 'react'

import RadioForm from 'components/RadioForm'
import { formatFullLocation } from 'utils'
import { colors } from 'themes'
import { Location } from '.'

import {
	Container,
	Header,
	InfoText,
	LocationText,
	LocationNoCardIcon,
	AddLocationButton,
	ConfirmCancelButtons,
} from './BillingLocationSelector.styles'

interface BillingLocationSelectorProps {
	locations: Array<Location>,
	onAddLocation: () => any,
	onSelected: (item: Location | null) => any,
	onCancel: () => any,
}

export default function BillingLocationSelector(
	{
		locations,
		onAddLocation,
		onCancel,
		onSelected,
		...props
	}: BillingLocationSelectorProps,
) {
	const [selectedLocation, setSelectedLocation] = useState<Location | null>(null)

	return (
		<Container {...props}>
			<Header>
				Select Billing Location
			</Header>
			<InfoText>
				Tokens never expire, and you can use
				them to view candidate resumes on
				Job Board postings from any of your
				office locations.
			</InfoText>
			<LocationRadio
				locations={locations}
				selectedLocation={selectedLocation}
				onSetLocation={setSelectedLocation}
			/>
			<AddLocationButton
				onClick={onAddLocation}
			>
				Add Location
			</AddLocationButton>
			<ConfirmCancelButtons
				confirmDisabled={!selectedLocation}

				confirmText={'OK'}
				cancelText={'Cancel'}
				onConfirm={
					useCallback(
						() => onSelected(selectedLocation),
						[onSelected, selectedLocation],
					)
				}
				onCancel={onCancel}
			/>
		</Container>
	)
}

interface LocationRadioProps {
	locations: Array<Location>,
	selectedLocation: Location | null,
	onSetLocation: (location: Location) => any,
	hideCardsInfo?: boolean
}

export function LocationRadio(
	{
		locations,
		selectedLocation,
		onSetLocation,
		hideCardsInfo,
	}: LocationRadioProps,
) {
	return (
		<RadioForm<Location>
			items={locations}
			selected={selectedLocation}
			onSelected={onSetLocation}
			keyExtractor={useCallback(({ id }) => id, [])}
			getFade={({ hasCard }) => ({ width: '75px', rightEndPercent: hasCard ? 60 : 40 })}
			renderItem={({ item }) => (
				<>
					<LocationText>
						{formatFullLocation(item)}
					</LocationText>
					{
						!hideCardsInfo && !item.hasCard && (
							<LocationNoCardIcon />
						)
					}
				</>
			)}
			background={colors.billingLocation.background}
			selectionBackground={colors.billingLocation.selectedBackground}
		/>
	)
}
